<template>
    <div class="modal fade" id="createTempRankingCanddateModal" role="dialog" aria-labelledby="createTempRankingCanddateModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" style="min-width: 1400px;" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="createTempRankingCanddateModalLabel">{{$t('registers.events.evaluation.tempRanking.editor.create')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <TempRankingCandidateEditCard v-model="model"
                                      v-if="showEditor"
                                      :create="true"
                                      :validateUniqueIdNumber="false"
                                      :validateEgn="true"
                                      @save="onSave"
                                      @cancel="onCancel">
                    </TempRankingCandidateEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Participant } from '@/models/models';
    import TempRankingCandidateEditCard from './TempRankingCandidateEditCard';

    export default {
        components: {
            TempRankingCandidateEditCard
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showEditor: false,
                model: new Participant(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Participant();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Participant();
                    this.model.entryId = this.$store.getters.currentRegister.registerEntryId;
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
